import axios from 'axios';
import { filter, first, from, map, Observable, switchMap } from 'rxjs';

import { addresses$ } from '../../../api/addresses/addresses';
import { selectedWallet$ } from '../../../api/wallet/wallet';
import { applicationConfig } from '../../../applicationConfig';

export const getAccessToken = (): Observable<string> =>
  addresses$.pipe(
    filter((addresses) => addresses.length > 0),
    first(),
    switchMap((addresses) =>
      selectedWallet$.pipe(
        filter(Boolean),
        first(),
        switchMap((w) => w.getChangeAddress()),
        switchMap((address) =>
          from(
            axios.post(
              `${applicationConfig.kycUrl}verification/getAccessToken`,
              {
                address,
                addresses,
              },
            ),
          ),
        ),
      ),
    ),
    map((res) => res.data.token),
  );
